const CONNECTOR_INTERNAL_NAME_LINKEDIN: string = 'webdata-direct:linkedin-snap';
const CONNECTOR_INTERNAL_NAME_MARKETO: string = 'webdata-direct:marketo-marketo';
const CONNECTOR_INTERNAL_NAME_ELOQUA: string = 'webdata-direct:oracle-eloqua';
const CONNECTOR_INTERNAL_NAME_SALESFORCE: string = 'salesforce';
const CONNECTOR_INTERNAL_NAME_SERVICENOW: string = 'webdata-direct:ServiceNowITSM-ServiceNowITSM';

export const CONNECTOR_SORTED_LIST_FOR_CHANNEL: string[] = [
  CONNECTOR_INTERNAL_NAME_SALESFORCE,
  CONNECTOR_INTERNAL_NAME_MARKETO,
  CONNECTOR_INTERNAL_NAME_ELOQUA,
  CONNECTOR_INTERNAL_NAME_SERVICENOW,
  CONNECTOR_INTERNAL_NAME_LINKEDIN,
];

export const TWO_ROWS: number = 2;
